module.exports = __webpack_public_path__ + "img/ic-close.655fda26.svg";